module.exports = __webpack_public_path__ + "static/media/IOTSU_S1.71d0c199.jpg";